import script from "./BooksView.vue?vue&type=script&setup=true&lang=js"
export * from "./BooksView.vue?vue&type=script&setup=true&lang=js"

import "./BooksView.vue?vue&type=style&index=0&id=31964a16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31964a16"]])

export default __exports__